import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import EstimateAction from "./EstimateAction";
import EstimateModel from "./models/EstimateModel";
import EstimatePrintabelModel from "./models/EstimatePrintabelModel";
import IEstimateState from "./models/IEstimateState";

export default class EstimateReducer extends BaseReducer<IEstimateState> {
    public readonly initialState: IEstimateState = {
        estimate: new EstimateModel({}),
        estimatePrintable: new EstimatePrintabelModel({}),
    };

    public [EstimateAction.REQUEST_ESTIMATE_FINISHED](
        state: IEstimateState,
        action: IAction<EstimateModel>
    ): IEstimateState {
        return {
            ...state,
            estimate: action.payload!,
            estimatePrintable: new EstimatePrintabelModel({}),
        };
    }
    public [EstimateAction.REQUEST_ESTIMATE_PRINT_FINISHED](
        state: IEstimateState,
        action: IAction<EstimatePrintabelModel>
    ): IEstimateState {
        return {
            ...state,
            estimatePrintable: action.payload!,
        };
    }
    public [EstimateAction.REQUEST_ESTIMATE_RESET](
        state: IEstimateState,
        action: IAction<EstimateModel>
    ): IEstimateState {
        return {
            ...state,
            estimate: this.initialState.estimate,
        };
    }
}
